<template>
    <div class="video-holder">
        <iframe :src="`${props.videoLink}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479`" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" title="Tutorial" />
    </div>
</template>

<script setup lang="ts">

const props = defineProps<{
    videoLink: string;
}>();

</script>

<style lang="scss" scoped>
.video-holder {
    position: relative;
    iframe {
        height: 720px;
        width: 1280px;
        @include responsive('xl') {
            height: 430px;
            width: 764px;
        }
    }
}
</style>
